<script setup lang="ts">
const locale = await getLocale("ko", "request_expired");

defineComponent({
    name: "RequestExpired"
})

const emit = defineEmits(["init"])

onMounted(() => {
    emit("init");
    // window.setTimeout(() => {
    //     location.href = 'https://www.creditocofidis.it'
    // }, 5000)
})

</script>
<template>
    <div class="mx-auto lg:container text-sm sm:text-base leading-tight text-gray-700 py-4">
        <div class="absolute inset-0 flex items-center justify-center z-10  top-24 sm:top-0">
            <div class="modal-wrapper bg-white mx-4 text-center rounded-3xl mb-64 max-w-xl text-gray-700 shadow-xl">
                <div class="p-4">
                    <i class="icon clock block mx-auto"></i>
                    <h1 class="text-3xl sm:text-3xl font-semibold md:w-2/3 mx-auto mt-4">{{ locale.title }}</h1>
                </div>
                <div class="bg-yellow-4 p-4 rounded-b-3xl">
                    <p>{{ locale.message }}<strong>{{ locale.value }}</strong>{{ locale.message2 }}<strong>{{ locale.message3 }}</strong>.</p>
                    <a class="rounded-full border border-black py-2 px-8 mt-4 inline-block mx-auto" href="https://www.creditocofidis.it">
                        <span class="mr-4">{{ locale.cta }}</span>
                        <i class="icon arrowright inline-block"></i>
                    </a>
                    <p class="my-6">{{ locale.redirect }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
